// =======================================================
// Variables
// =======================================================

// Const Global
const body              = document.querySelector('body');
const menu              = document.querySelector('#js-NavMain');
const menuItems         = document.querySelectorAll('#js-NavMain .menu__item');
const menuLinks         = document.querySelectorAll('#js-NavMain .menu__link');

// Const Simple Menu
const menuSimple        = menu.classList.contains('nav-main--simple');
const menuOpen          = document.querySelector('#js-OpenMenu');
const menuClose         = document.querySelector('#js-CloseMenu');
const subMenuCloses     = document.querySelectorAll('.nav-main .submenu__close');

// Const Burger Menu
const menuBurger        = menu.classList.contains('nav-main--burger');
const menuOpenClose     = document.querySelector('#js-OpenCloseMenu');
const menuCloseA11y     = document.querySelector('#js-CloseMenuA11y');
const subMenuClose      = document.querySelector('#js-CloseSubmenu');
const buttonscontainer  = document.querySelector('.nav-main-buttons');
const menuSvg           = document.querySelector('.menu__svg');


// =======================================================
// Simple responsive Menu
// =======================================================
if (menuSimple) {

    // Check if condition
    // console.log('If classlist contains nav-main--simple');

    // Open menu
    menuOpen.addEventListener('click', function () {
        menu.classList.add('js-active-menu');
        body.classList.add('js-active-navmain');
    });

    // Close menu
    menuClose.addEventListener('click', function () {
        menu.classList.remove('js-active-menu');
        body.classList.remove('js-active-navmain');
    });


    // Open submenu
    menuLinks.forEach(function (menuLink) {
        menuLink.addEventListener('click', function () {
            this.parentElement.classList.add('js-active-submenu');
            // Check added class
            // console.log("Add js-active-submenu");
        });

    });

    // Close submenu
    subMenuCloses.forEach(function (subMenuClose) {
        subMenuClose.addEventListener('click', function () {
            this.closest('.menu__item').classList.remove('js-active-submenu');
            // Check deleted class
            // console.log("Remove js-active-submenu");
        });
    });

}


// =======================================================
// Burger Menu
// =======================================================
if (menuBurger) {

    // Check if condition
    // console.log('If classlist contains nav-main--burger');

    // ---------------------------------------------------
    // Open/Close menu (with button a11y for close menu)
    // ---------------------------------------------------

    // Function menu button (for close menu) : Change title
    function OpenMenuTitle(menuOpenClose) {
        menuOpenClose.setAttribute('title', "Accéder au menu principal");
    }

    // Function menu button (for open menu) : Change title
    function CloseMenuTitle(menuOpenClose) {
        menuOpenClose.setAttribute('title', "Fermer le menu principal");
    }

    // Function A11y button active : Tabindex in DOM
    function TabindexDOM(menuCloseA11y) {
        menuCloseA11y.setAttribute('tabindex', 0);
    }

    // Function A11y button inactive : Tabindex removed from DOM
    function TabindexOutDOM(menuCloseA11y) {
        menuCloseA11y.setAttribute('tabindex', -1);
    }

    // Open/Close menu Fonction
    function OpenCloseMenu() {

        // Variables
        let menuBurgerActive = menu.classList.contains('js-active-menu');

        // If Burger menu active
        if (menuBurgerActive) {

            // Check condition
            // console.log ("if menuburger ACTIVE");

            // Close menu
            menu.classList.remove('js-active-menu');

            // A11y button inactive
            TabindexOutDOM(menuCloseA11y);

            // Change title button
            OpenMenuTitle(menuOpenClose);

            menuItems.forEach(function (menuItem) {

                    // Close submenu
                    menuItem.classList.remove('js-active-submenu');

            });

        } else {

            // Check condition
            // console.log ("if menuburger NOT ACTIVE");

            // Open menu
            menu.classList.add('js-active-menu');

            // A11y button active
            TabindexDOM(menuCloseA11y);

            // Change title button
            CloseMenuTitle(menuOpenClose);

        }

        body.classList.toggle('js-active-navmainburger');
    }

    // Close menu
    menuOpenClose.addEventListener('click', () => {
        OpenCloseMenu(menuOpenClose);
    });

    // Close menu with A11y button
    menuCloseA11y.addEventListener('click', () => {
        OpenCloseMenu(menuCloseA11y);
    });


    // ---------------------------------------------------
    // Open/Close submenu
    // ---------------------------------------------------

    menuLinks.forEach(function (menuLink) {

        function OpenCloseSubmenu(menuLink) {

            // Variables
            let menuLinkParent = menuLink.parentElement;
            let menuLinkParentActive = menuLinkParent.classList.contains('js-active-submenu');

            menuItems.forEach(function (menuItem) {

                // Variables
                let menuItemActive = menuItem.classList.contains('js-active-submenu');

                // If submenu open : Remove js-active-submenu
                if (menuItemActive) {

                    // Close submenu
                    menuItem.classList.remove('js-active-submenu');

                    // Check class removed
                    // console.log("REMOVE menuItem ACTIVE");
                }

            });

            // If submenu close : Add js-active-submenu
            if (!menuLinkParentActive) {

                // Open submenu
                menuLinkParent.classList.add('js-active-submenu');
                buttonscontainer.classList.add('js-active-submenu');
                menu.classList.add('js-active-submenu');

                // Check class added
                // console.log("ADD menuLinkParent ACTIVE");
            }

        }

        // Event click
        menuLink.addEventListener('click', () => {
            OpenCloseSubmenu(menuLink);
        });

    });


    // ---------------------------------------------------
    // Responsive submenu close
    // ---------------------------------------------------

    subMenuClose.addEventListener('click', function () {

        menuItems.forEach(function (menuItem) {

            // Close submenu
            menuItem.classList.remove('js-active-submenu');
            buttonscontainer.classList.remove('js-active-submenu');
            menu.classList.remove('js-active-submenu');

            // Check deleted class
            // console.log("Remove js-active-submenu");
        });
        
    });

    // ---------------------------------------------------
    // Gestion du triangle_menu
    // ---------------------------------------------------

    function handleMenuItemClick(index) {
        // Vérifier si l'élément .menu__item possède la classe js-active-submenu pour faire apparaître le triangle
        const menuItem = menuItems[index];
        const isActiveSubmenu = menuItem.classList.contains('js-active-submenu');
        
        if (isActiveSubmenu) {
            // Définition des valeurs du top
            const topValues = [25, 93, 162, 232];
        
            // Vérification de l'index pour attribuer le top correct
            if (index >= 0 && index < topValues.length) {
                const topValue = topValues[index];
                menuSvg.style.top = topValue + 'px';
            }
        
            menuSvg.style.opacity = '1';

        } else {
            // Faire disparaître le top si pas d'élément .menu__item cliqué
            menuSvg.style.opacity = '0';
        }
    }
      
    // Fonction pour gérer le clic sur n'importe quel élément .menu__item
    function handleAnyMenuItemClick() {
        // Remise à zéro de l'opacité et du top pour l'état par défaut
        menuSvg.style.opacity = '0';
    }
    
    menuItems.forEach((menuItem, index) => {
        menuItem.addEventListener('click', () => {
            handleMenuItemClick(index);
        });
    });
    
    document.addEventListener('click', (event) => {
        // Vérification pour s'assurer qu'un élément .menu__item a été cliqué
        if (!event.target.closest('.menu__item')) {
            handleAnyMenuItemClick();
        }
    });
}

// Empêcher les entrées principales de rediriger
menuLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();
    });
});

//Masquer le sticky en mobile quand le submenu est ouvert
window.addEventListener("DOMContentLoaded", function() {
    function handleStickyDisplay() {
        const screenSize = window.innerWidth;
        const menuItems = document.querySelectorAll(".menu__item");
        const stickyElement = document.querySelector(".sticky");

        if (screenSize <= 960) {
            let shouldHideSticky = false;

            menuItems.forEach(item => {
                if (item.classList.contains("js-active-submenu")) {
                    shouldHideSticky = true;
                }
            });

            if (shouldHideSticky) {
                stickyElement.style.display = "none";
            } else {
                stickyElement.style.display = "flex";
            }
        } else {
            stickyElement.style.display = "none";
        }
    }

    window.addEventListener("resize", handleStickyDisplay);

    handleStickyDisplay();

    const observer = new MutationObserver(handleStickyDisplay);
    const config = { attributes: true, attributeFilter: ["class"] };

    document.querySelectorAll(".menu__item").forEach(item => {
        observer.observe(item, config);
    });
});


